import React from 'react';

import { Eduzz as EduzzIcon } from '@profitfy/pakkun-icons';
import { EHeadingSize, EHeadingWeight } from '@domain/enums/components/EHeading';
import { IEduzzConfigProps } from '@domain/interfaces/dashboard/IntegrationCenter/InfoProduct/IEduzz';

import CredentialOption from './CredentialOption';
import SyncOption from './SyncOption';

import * as S from './styles';

const EduzzConfig: React.FC<IEduzzConfigProps> = ({ credential }) => {
  const [selectedTab, setSelectedTab] = React.useState<number>(0);

  const onChangeTab = React.useCallback(index => setSelectedTab(index), []);

  return (
    <S.ContentWrapper>
      <S.Header>
        <EduzzIcon size={52} />
        <S.Heading type={EHeadingSize.H4} fontWeight={EHeadingWeight.REGULAR}>
          Integração com Eduzz
        </S.Heading>
      </S.Header>

      <S.Tab defaultTab={selectedTab} onChangeTab={onChangeTab}>
        <S.Option>Geral</S.Option>
        <S.Option>Sincronização</S.Option>
      </S.Tab>

      {selectedTab === 0 && <CredentialOption credential={credential} />}
      {selectedTab === 1 && <SyncOption />}
    </S.ContentWrapper>
  );
};

export default EduzzConfig;
